$(document).ready(function () {
  $("#signInBtn").on("click", function () {
    $.dhnPopup.open({
      popupId: "#dhn-sign-in",
      backdropId: "#dhn-sign-in-backdrop",
      position: "center",
      animation: "fade-in",
      hasBackdrop: true,
      showOnce: "none",
      localStorageKey: "signInPopup",
    });
  });
});

const stickyThreshold = 100; // px

$(window).on("scroll", function () {
  if ($(this).scrollTop() > stickyThreshold) {
    $("header").addClass("sticky");
  } else {
    $("header").removeClass("sticky");
  }
});
